import AE from "@assets/images/country-flags/png100px/ae.png";
import AF from "@assets/images/country-flags/png100px/af.png";
import AG from "@assets/images/country-flags/png100px/ag.png";
import AI from "@assets/images/country-flags/png100px/ai.png";
import AL from "@assets/images/country-flags/png100px/al.png";
import AM from "@assets/images/country-flags/png100px/am.png";
import AO from "@assets/images/country-flags/png100px/ao.png";
import AQ from "@assets/images/country-flags/png100px/aq.png";
import AR from "@assets/images/country-flags/png100px/ar.png";
import AS from "@assets/images/country-flags/png100px/as.png";
import AT from "@assets/images/country-flags/png100px/at.png";
import AU from "@assets/images/country-flags/png100px/au.png";
import AW from "@assets/images/country-flags/png100px/aw.png";
import AX from "@assets/images/country-flags/png100px/ax.png";
import AZ from "@assets/images/country-flags/png100px/az.png";
import BA from "@assets/images/country-flags/png100px/ba.png";
import BB from "@assets/images/country-flags/png100px/bb.png";
import BD from "@assets/images/country-flags/png100px/bd.png";
import BE from "@assets/images/country-flags/png100px/be.png";
import BF from "@assets/images/country-flags/png100px/bf.png";
import BG from "@assets/images/country-flags/png100px/bg.png";
import BH from "@assets/images/country-flags/png100px/bh.png";
import BI from "@assets/images/country-flags/png100px/bi.png";
import BJ from "@assets/images/country-flags/png100px/bj.png";
import BL from "@assets/images/country-flags/png100px/bl.png";
import BM from "@assets/images/country-flags/png100px/bm.png";
import BN from "@assets/images/country-flags/png100px/bn.png";
import BO from "@assets/images/country-flags/png100px/bo.png";
import BQ from "@assets/images/country-flags/png100px/bq.png";
import BR from "@assets/images/country-flags/png100px/br.png";
import BS from "@assets/images/country-flags/png100px/bs.png";
import BT from "@assets/images/country-flags/png100px/bt.png";
import BV from "@assets/images/country-flags/png100px/bv.png";
import BW from "@assets/images/country-flags/png100px/bw.png";
import BY from "@assets/images/country-flags/png100px/by.png";
import BZ from "@assets/images/country-flags/png100px/bz.png";
import CA from "@assets/images/country-flags/png100px/ca.png";
import CC from "@assets/images/country-flags/png100px/cc.png";
import CD from "@assets/images/country-flags/png100px/cd.png";
import CF from "@assets/images/country-flags/png100px/cf.png";
import CG from "@assets/images/country-flags/png100px/cg.png";
import CH from "@assets/images/country-flags/png100px/ch.png";
import CI from "@assets/images/country-flags/png100px/ci.png";
import CK from "@assets/images/country-flags/png100px/ck.png";
import CL from "@assets/images/country-flags/png100px/cl.png";
import CM from "@assets/images/country-flags/png100px/cm.png";
import CN from "@assets/images/country-flags/png100px/cn.png";
import CO from "@assets/images/country-flags/png100px/co.png";
import CR from "@assets/images/country-flags/png100px/cr.png";
import CU from "@assets/images/country-flags/png100px/cu.png";
import CV from "@assets/images/country-flags/png100px/cv.png";
import CW from "@assets/images/country-flags/png100px/cw.png";
import CX from "@assets/images/country-flags/png100px/cx.png";
import CY from "@assets/images/country-flags/png100px/cy.png";
import CZ from "@assets/images/country-flags/png100px/cz.png";
import DE from "@assets/images/country-flags/png100px/de.png";
import DJ from "@assets/images/country-flags/png100px/dj.png";
import DK from "@assets/images/country-flags/png100px/dk.png";
import DM from "@assets/images/country-flags/png100px/dm.png";
import DO from "@assets/images/country-flags/png100px/do.png";
import DZ from "@assets/images/country-flags/png100px/dz.png";
import EC from "@assets/images/country-flags/png100px/ec.png";
import EE from "@assets/images/country-flags/png100px/ee.png";
import EG from "@assets/images/country-flags/png100px/eg.png";
import EH from "@assets/images/country-flags/png100px/eh.png";
import ER from "@assets/images/country-flags/png100px/er.png";
import ES from "@assets/images/country-flags/png100px/es.png";
import ET from "@assets/images/country-flags/png100px/et.png";
import EU from "@assets/images/country-flags/png100px/eu.png";
import FI from "@assets/images/country-flags/png100px/fi.png";
import FJ from "@assets/images/country-flags/png100px/fj.png";
import FK from "@assets/images/country-flags/png100px/fk.png";
import FM from "@assets/images/country-flags/png100px/fm.png";
import FO from "@assets/images/country-flags/png100px/fo.png";
import FR from "@assets/images/country-flags/png100px/fr.png";
import GA from "@assets/images/country-flags/png100px/ga.png";
import GB from "@assets/images/country-flags/png100px/gb.png";
import GD from "@assets/images/country-flags/png100px/gd.png"
import GE from "@assets/images/country-flags/png100px/ge.png"
import GF from "@assets/images/country-flags/png100px/gf.png"
import GG from "@assets/images/country-flags/png100px/gg.png"
import GH from "@assets/images/country-flags/png100px/gh.png"
import GI from "@assets/images/country-flags/png100px/gi.png"
import GL from "@assets/images/country-flags/png100px/gl.png"
import GM from "@assets/images/country-flags/png100px/gm.png"
import GN from "@assets/images/country-flags/png100px/gn.png"
import GP from "@assets/images/country-flags/png100px/gp.png"
import GQ from "@assets/images/country-flags/png100px/gq.png"
import GR from "@assets/images/country-flags/png100px/gr.png"
import GS from "@assets/images/country-flags/png100px/gs.png"
import GT from "@assets/images/country-flags/png100px/gt.png"
import GU from "@assets/images/country-flags/png100px/gu.png"
import GW from "@assets/images/country-flags/png100px/gw.png"
import GY from "@assets/images/country-flags/png100px/gy.png"
import HK from "@assets/images/country-flags/png100px/hk.png"
import HM from "@assets/images/country-flags/png100px/hm.png"
import HN from "@assets/images/country-flags/png100px/hn.png"
import HR from "@assets/images/country-flags/png100px/hr.png"
import HT from "@assets/images/country-flags/png100px/ht.png"
import HU from "@assets/images/country-flags/png100px/hu.png"
import ID from "@assets/images/country-flags/png100px/id.png"
import IE from "@assets/images/country-flags/png100px/ie.png"
import IL from "@assets/images/country-flags/png100px/il.png"
import IM from "@assets/images/country-flags/png100px/im.png"
import IN from "@assets/images/country-flags/png100px/in.png"
import IO from "@assets/images/country-flags/png100px/io.png"
import IQ from "@assets/images/country-flags/png100px/iq.png"
import IR from "@assets/images/country-flags/png100px/ir.png"
import IS from "@assets/images/country-flags/png100px/is.png"
import IT from "@assets/images/country-flags/png100px/it.png"
import JE from "@assets/images/country-flags/png100px/je.png"
import JM from "@assets/images/country-flags/png100px/jm.png"
import JO from "@assets/images/country-flags/png100px/jo.png"
import JP from "@assets/images/country-flags/png100px/jp.png"
import KE from "@assets/images/country-flags/png100px/ke.png"
import KG from "@assets/images/country-flags/png100px/kg.png"
import KH from "@assets/images/country-flags/png100px/kh.png"
import KI from "@assets/images/country-flags/png100px/ki.png"
import KM from "@assets/images/country-flags/png100px/km.png"
import KN from "@assets/images/country-flags/png100px/kn.png"
import KP from "@assets/images/country-flags/png100px/kp.png"
import KR from "@assets/images/country-flags/png100px/kr.png"
import KW from "@assets/images/country-flags/png100px/kw.png"
import KY from "@assets/images/country-flags/png100px/ky.png"
import KZ from "@assets/images/country-flags/png100px/kz.png"
import LA from "@assets/images/country-flags/png100px/la.png"
import LB from "@assets/images/country-flags/png100px/lb.png"
import LC from "@assets/images/country-flags/png100px/lc.png"
import LI from "@assets/images/country-flags/png100px/li.png"
import LK from "@assets/images/country-flags/png100px/lk.png"
import LR from "@assets/images/country-flags/png100px/lr.png"
import LS from "@assets/images/country-flags/png100px/ls.png"
import LT from "@assets/images/country-flags/png100px/lt.png"
import LU from "@assets/images/country-flags/png100px/lu.png"
import LV from "@assets/images/country-flags/png100px/lv.png"
import LY from "@assets/images/country-flags/png100px/ly.png"
import MA from "@assets/images/country-flags/png100px/ma.png"
import MC from "@assets/images/country-flags/png100px/mc.png"
import MD from "@assets/images/country-flags/png100px/md.png"
import ME from "@assets/images/country-flags/png100px/me.png"
import MF from "@assets/images/country-flags/png100px/mf.png"
import MG from "@assets/images/country-flags/png100px/mg.png"
import MH from "@assets/images/country-flags/png100px/mh.png"
import MK from "@assets/images/country-flags/png100px/mk.png"
import ML from "@assets/images/country-flags/png100px/ml.png"
import MM from "@assets/images/country-flags/png100px/mm.png"
import MN from "@assets/images/country-flags/png100px/mn.png"
import MO from "@assets/images/country-flags/png100px/mo.png"
import MP from "@assets/images/country-flags/png100px/mp.png"
import MQ from "@assets/images/country-flags/png100px/mq.png"
import MR from "@assets/images/country-flags/png100px/mr.png"
import MS from "@assets/images/country-flags/png100px/ms.png"
import MT from "@assets/images/country-flags/png100px/mt.png"
import MU from "@assets/images/country-flags/png100px/mu.png"
import MV from "@assets/images/country-flags/png100px/mv.png"
import MW from "@assets/images/country-flags/png100px/mw.png"
import MX from "@assets/images/country-flags/png100px/mx.png"
import MY from "@assets/images/country-flags/png100px/my.png"
import MZ from "@assets/images/country-flags/png100px/mz.png"
import NA from "@assets/images/country-flags/png100px/na.png"
import NC from "@assets/images/country-flags/png100px/nc.png"
import NE from "@assets/images/country-flags/png100px/ne.png"
import NF from "@assets/images/country-flags/png100px/nf.png"
import NG from "@assets/images/country-flags/png100px/ng.png"
import NI from "@assets/images/country-flags/png100px/ni.png"
import NL from "@assets/images/country-flags/png100px/nl.png"
import NO from "@assets/images/country-flags/png100px/no.png"
import NP from "@assets/images/country-flags/png100px/np.png"
import NR from "@assets/images/country-flags/png100px/nr.png"
import NU from "@assets/images/country-flags/png100px/nu.png"
import NZ from "@assets/images/country-flags/png100px/nz.png"
import OM from "@assets/images/country-flags/png100px/om.png"
import PA from "@assets/images/country-flags/png100px/pa.png"
import PE from "@assets/images/country-flags/png100px/pe.png"
import PF from "@assets/images/country-flags/png100px/pf.png"
import PG from "@assets/images/country-flags/png100px/pg.png"
import PH from "@assets/images/country-flags/png100px/ph.png"
import PK from "@assets/images/country-flags/png100px/pk.png"
import PL from "@assets/images/country-flags/png100px/pl.png"
import PM from "@assets/images/country-flags/png100px/pm.png"
import PN from "@assets/images/country-flags/png100px/pn.png"
import PR from "@assets/images/country-flags/png100px/pr.png"
import PS from "@assets/images/country-flags/png100px/ps.png"
import PT from "@assets/images/country-flags/png100px/pt.png"
import PW from "@assets/images/country-flags/png100px/pw.png"
import PY from "@assets/images/country-flags/png100px/py.png"
import QA from "@assets/images/country-flags/png100px/qa.png"
import RE from "@assets/images/country-flags/png100px/re.png"
import RO from "@assets/images/country-flags/png100px/ro.png"
import RS from "@assets/images/country-flags/png100px/rs.png"
import RU from "@assets/images/country-flags/png100px/ru.png"
import RW from "@assets/images/country-flags/png100px/rw.png"
import SA from "@assets/images/country-flags/png100px/sa.png"
import SB from "@assets/images/country-flags/png100px/sb.png"
import SC from "@assets/images/country-flags/png100px/sc.png"
import SD from "@assets/images/country-flags/png100px/sd.png"
import SE from "@assets/images/country-flags/png100px/se.png"
import SG from "@assets/images/country-flags/png100px/sg.png"
import SH from "@assets/images/country-flags/png100px/sh.png"
import SI from "@assets/images/country-flags/png100px/si.png"
import SJ from "@assets/images/country-flags/png100px/sj.png"
import SK from "@assets/images/country-flags/png100px/sk.png"
import SL from "@assets/images/country-flags/png100px/sl.png"
import SM from "@assets/images/country-flags/png100px/sm.png"
import SN from "@assets/images/country-flags/png100px/sn.png"
import SO from "@assets/images/country-flags/png100px/so.png"
import SR from "@assets/images/country-flags/png100px/sr.png"
import SS from "@assets/images/country-flags/png100px/ss.png"
import ST from "@assets/images/country-flags/png100px/st.png"
import SV from "@assets/images/country-flags/png100px/sv.png"
import SX from "@assets/images/country-flags/png100px/sx.png"
import SY from "@assets/images/country-flags/png100px/sy.png"
import SZ from "@assets/images/country-flags/png100px/sz.png"
import TC from "@assets/images/country-flags/png100px/tc.png"
import TD from "@assets/images/country-flags/png100px/td.png"
import TF from "@assets/images/country-flags/png100px/tf.png"
import TG from "@assets/images/country-flags/png100px/tg.png"
import TH from "@assets/images/country-flags/png100px/th.png"
import TJ from "@assets/images/country-flags/png100px/tj.png"
import TK from "@assets/images/country-flags/png100px/tk.png"
import TL from "@assets/images/country-flags/png100px/tl.png"
import TM from "@assets/images/country-flags/png100px/tm.png"
import TN from "@assets/images/country-flags/png100px/tn.png"
import TO from "@assets/images/country-flags/png100px/to.png"
import TR from "@assets/images/country-flags/png100px/tr.png"
import TT from "@assets/images/country-flags/png100px/tt.png"
import TV from "@assets/images/country-flags/png100px/tv.png"
import TW from "@assets/images/country-flags/png100px/tw.png"
import TZ from "@assets/images/country-flags/png100px/tz.png"
import UA from "@assets/images/country-flags/png100px/ua.png"
import UG from "@assets/images/country-flags/png100px/ug.png"
import UM from "@assets/images/country-flags/png100px/um.png"
import US from "@assets/images/country-flags/png100px/us.png"
import UY from "@assets/images/country-flags/png100px/uy.png"
import UZ from "@assets/images/country-flags/png100px/uz.png"
import VA from "@assets/images/country-flags/png100px/va.png"
import VC from "@assets/images/country-flags/png100px/vc.png"
import VE from "@assets/images/country-flags/png100px/ve.png"
import VG from "@assets/images/country-flags/png100px/vg.png"
import VI from "@assets/images/country-flags/png100px/vi.png"
import VN from "@assets/images/country-flags/png100px/vn.png"
import VU from "@assets/images/country-flags/png100px/vu.png"
import WF from "@assets/images/country-flags/png100px/wf.png"
import WS from "@assets/images/country-flags/png100px/ws.png"
import XK from "@assets/images/country-flags/png100px/xk.png"
import YE from "@assets/images/country-flags/png100px/ye.png"
import YT from "@assets/images/country-flags/png100px/yt.png"
import ZA from "@assets/images/country-flags/png100px/za.png"
import ZM from "@assets/images/country-flags/png100px/zm.png"
import ZW from "@assets/images/country-flags/png100px/zw.png"
import AD from "@assets/images/country-flags/png100px/ad.png"

import GB_ENG from "@assets/images/country-flags/png100px/gb-eng.png"
import GB_NIR from "@assets/images/country-flags/png100px/gb-nir.png"
import GB_SCT from "@assets/images/country-flags/png100px/gb-sct.png"
import GB_WLS from "@assets/images/country-flags/png100px/gb-wls.png"

export const COUNTRY_FLAGS = {
    AE
    , AF
    , AG
    , AI
    , AL
    , AM
    , AO
    , AQ
    , AR
    , AS
    , AT
    , AU
    , AW
    , AX
    , AZ
    , BA
    , BB
    , BD
    , BE
    , BF
    , BG
    , BH
    , BI
    , BJ
    , BL
    , BM
    , BN
    , BO
    , BQ
    , BR
    , BS
    , BT
    , BV
    , BW
    , BY
    , BZ
    , CA
    , CC
    , CD
    , CF
    , CG
    , CH
    , CI
    , CK
    , CL
    , CM
    , CN
    , CO
    , CR
    , CU
    , CV
    , CW
    , CX
    , CY
    , CZ
    , DE
    , DJ
    , DK
    , DM
    , DO
    , DZ
    , EC
    , EE
    , EG
    , EH
    , ER
    , ES
    , ET
    , EU
    , FI
    , FJ
    , FK
    , FM
    , FO
    , FR
    , GA
    , GB
    , GD
    , GE
    , GF
    , GG
    , GH
    , GI
    , GL
    , GM
    , GN
    , GP
    , GQ
    , GR
    , GS
    , GT
    , GU
    , GW
    , GY
    , HK
    , HM
    , HN
    , HR
    , HT
    , HU
    , ID
    , IE
    , IL
    , IM
    , IN
    , IO
    , IQ
    , IR
    , IS
    , IT
    , JE
    , JM
    , JO
    , JP
    , KE
    , KG
    , KH
    , KI
    , KM
    , KN
    , KP
    , KR
    , KW
    , KY
    , KZ
    , LA
    , LB
    , LC
    , LI
    , LK
    , LR
    , LS
    , LT
    , LU
    , LV
    , LY
    , MA
    , MC
    , MD
    , ME
    , MF
    , MG
    , MH
    , MK
    , ML
    , MM
    , MN
    , MO
    , MP
    , MQ
    , MR
    , MS
    , MT
    , MU
    , MV
    , MW
    , MX
    , MY
    , MZ
    , NA
    , NC
    , NE
    , NF
    , NG
    , NI
    , NL
    , NO
    , NP
    , NR
    , NU
    , NZ
    , OM
    , PA
    , PE
    , PF
    , PG
    , PH
    , PK
    , PL
    , PM
    , PN
    , PR
    , PS
    , PT
    , PW
    , PY
    , QA
    , RE
    , RO
    , RS
    , RU
    , RW
    , SA
    , SB
    , SC
    , SD
    , SE
    , SG
    , SH
    , SI
    , SJ
    , SK
    , SL
    , SM
    , SN
    , SO
    , SR
    , SS
    , ST
    , SV
    , SX
    , SY
    , SZ
    , TC
    , TD
    , TF
    , TG
    , TH
    , TJ
    , TK
    , TL
    , TM
    , TN
    , TO
    , TR
    , TT
    , TV
    , TW
    , TZ
    , UA
    , UG
    , UM
    , US
    , UY
    , UZ
    , VA
    , VC
    , VE
    , VG
    , VI
    , VN
    , VU
    , WF
    , WS
    , XK
    , YE
    , YT
    , ZA
    , ZM
    , ZW
    , AD
    , GB_ENG
    , GB_NIR
    , GB_SCT
    , GB_WLS
}